import * as _ from 'lodash';
import { sdcStateConfigConstant } from '../../../app/sdc/sdc-state/sdc-state-config.constant';
import { ISdcConfig } from '../../../app/sdc/sdc-state/sdc-state.typings';
import {
  TEffectiveRoleMap,
  TSchoolDelegatedRole,
  TValidUserRoles,
} from '../../../ng2/shared/typings/interfaces/user.interface';
import { ImUser } from '../services/im-models/im-user';

interface IUserRolePermissionsForStates {
  [state: string]: TValidUserRoles[];
}

// NOTE: If permissioning is not specified for a state, that state will inherit permissioning from its parent state
export const USER_ROLE_PERMISSIONS_FOR_STATES: IUserRolePermissionsForStates = {
  main: ['all'],
  // Note: 'main.cluster' --> school picker view
  'main.cluster': ['cluster_admin', { network_and_school: ImUser.checkPortfolioAccess } as TEffectiveRoleMap],
  'main.network': ['cluster_admin', 'network_only', 'network_and_school'],
  'main.networkSettings': [
    'cluster_admin',
    { network_only: ImUser.checkClusterUserManageStatus } as TEffectiveRoleMap,
    { network_and_school: ImUser.checkClusterUserManageStatus } as TEffectiveRoleMap,
  ],
  'main.school.my-supports': ['all'],
  'main.school.other-tools.program-changes-and-gap-plans': [
    'cluster_admin',
    'delegated_school_admin',
    'school_admin',
    'edit_all',
    'edit_caseload',
  ],
  'main.school.other-tools.next-term-planning': [
    'cluster_admin',
    'delegated_school_admin',
    'school_admin',
    'edit_all',
    'edit_caseload',
  ],
  'main.school.other-tools.synced-sheets': ['cluster_admin', 'delegated_school_admin', 'school_admin', 'edit_all'],
  'main.school.other-tools': ['cluster_admin', 'delegated_school_admin', 'school_admin', 'edit_all', 'edit_caseload'],
  'main.school.data-entry.assessments': [
    'cluster_admin',
    'delegated_school_admin',
    'school_admin',
    'edit_all',
    'edit_caseload',
  ],
  'main.school.data-uploads.college-list': ['cluster_admin', 'delegated_school_admin', 'school_admin', 'edit_all'],
  'main.school.data-uploads.gradebook': ['cluster_admin', 'delegated_school_admin', 'school_admin', 'edit_all'],
  'main.school.data-entry.admin-input': [
    'cluster_admin',
    'delegated_school_admin',
    'school_admin',
    'edit_all',
    'edit_caseload',
  ],
  // TODO: Determine required permissions. Also, access to ng2 routes to be determined by toggle at this time - JYR
  'main.school.lists': ['all'],
  'main.school.lists.summer-school': [
    'cluster_admin',
    'school_admin',
    'delegated_school_admin',
    'edit_all',
    'view_all',
  ],
  'main.school.settings': ['cluster_admin', 'school_admin', 'delegated_school_admin', 'edit_all'],
  'main.school.settings.activities': [
    'cluster_admin',
    'school_admin',
    'delegated_school_admin',
    'edit_caseload',
    'edit_all',
  ],
  'main.school.settings.supports': [
    'cluster_admin',
    'school_admin',
    'delegated_school_admin',
    'edit_caseload',
    'edit_all',
  ],
  'main.school.settings.assessments': ['cluster_admin', 'delegated_school_admin', 'school_admin', 'edit_all'],
  'main.school.settings.metrics-and-master-program': ['cluster_admin', 'school_admin', 'delegated_school_admin'],
  'main.school.settings.user-management': ['cluster_admin', 'delegated_school_admin', 'school_admin'],

  root: ['all'],
  login: ['all'],
  callback: ['all'],
  'privacy-and-terms': ['all'],
};

// Dynamically add sdcActivityConstant states
_.each(sdcStateConfigConstant, (activity: ISdcConfig) => {
  const state = activity.state;

  if (state) {
    const availableSdcViews = activity.availableSdcViews;

    if (availableSdcViews.length) {
      if (_.includes(availableSdcViews, 'grid')) {
        USER_ROLE_PERMISSIONS_FOR_STATES[state + '.grid'] = ['all'];
      }

      if (_.includes(availableSdcViews, 'profile')) {
        USER_ROLE_PERMISSIONS_FOR_STATES[state + '.profile'] = ['all'];
      }

      if (_.includes(availableSdcViews, 'wizard')) {
        USER_ROLE_PERMISSIONS_FOR_STATES[state + '.wizard'] = [
          'cluster_admin',
          'delegated_school_admin',
          'school_admin',
          'edit_all',
          'edit_caseload',
        ];
      }
    }
  }
});
